<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="毛利汇总" name="total">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<hispickup v-model="filterHisDate"></hispickup>
						</div>
						<div class="operator-col">
							<warehouse-input v-model="filterWarehouse"></warehouse-input>
						</div>
						<div class="operator-col">
							<bool-filter
								size="mini"
								v-model="filterFrontOrder.value"
								suffix-icon="el-icon-search"
								clearable
								data-model-name="Order"
								field="is_front_order"
								field-name="前台订单"
							></bool-filter>
						</div>
            <div class="operator-col">
              <enum-filter
                  size="mini"
                  v-model="filterExpressType.index"
                  placeholder="发货类型"
                  suffix-icon="el-icon-caret-bottom"
                  clearable
                  data-model-name="Order"
                  field="express_type"
              ></enum-filter>
            </div>
						<div class="operator-col">
							<customer-input
								:params="{type: 'Agent',allowCreate: false,placeholder:'客户'}"
								v-model="filterCustomer"
							></customer-input>
						</div>
          </div>
          <div class="operator">
						<div class="operator-col">
							<admin-input
								:params="{allowCreate: false, notUseMeAsDefault:true,placeholder:'销售'}"
								v-model="filterSaler"
							></admin-input>
						</div>
						<div class="operator-col">
							<classify-input v-model="filterClassify" size="mini"></classify-input>
						</div>
						<div class="operator-col">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
						<div class="operator-col">
							<product-input :params="{allowCreate: false,placeholder:'SPU 名/码'}" v-model="filterProduct"></product-input>
						</div>
						<div class="operator-col" style="width:133px">
							<el-select
									size="mini" v-model="filterMetagender.value" placeholder="性别">
								<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
								</el-option>
							</el-select>
						</div>
            <div class="operator-col">
              <el-button size="mini" type="primary" @click="doProfitExport('product_color',activeName)">按单品导出</el-button>
            </div>
            <div class="operator-col">
              <el-button size="mini" type="primary" @click="doProfitExport('brand',activeName)">按品牌导出</el-button>
            </div>
					</div>
				</div>
				<div class="content-box">
					<sum-table
						ref="sumTable"
						:data-model="editorDataModel"
						:search-filter="filterTableSearch"
						:warehouse-filter="filterWarehouse"
						:kv-filter="kvFilter"
						:date-filter="filterHisDate"
						:fields="sumFields"
						list-url="analyse/sums/all"
					></sum-table>
				</div>
				<div class="mt-3 content-box">
					<el-tabs v-model="activeNameDetail">
						<el-tab-pane label="按单品" name="product_color">
							<sum-group-table
								ref="sumGroupTable"
								data-model="Product_color"
								:kv-filter="kvFilter"
								:date-filter="filterHisDate"
								:warehouse-filter="filterWarehouse"
								:fields="sumGroupFields"
								:data-fields="dataFields"
								list-url="analyse/sum_group/product_color"
							></sum-group-table>
						</el-tab-pane>
						<el-tab-pane label="按品牌" name="brand">
							<sum-group-table
								ref="sumGroupTable"
								data-model="Brand"
								:kv-filter="kvFilter"
								:date-filter="filterHisDate"
								:warehouse-filter="filterWarehouse"
								:fields="sumGroupFields"
								:data-fields="dataBrandFields"
								list-url="analyse/sum_group/brand"
							></sum-group-table>
						</el-tab-pane>
					</el-tabs>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSaler from "@/mixins/Filter/FilterSaler.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";
import FilterCustomer from "@/mixins/Filter/FilterCustomer.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import FilterProduct from "@/mixins/Filter/FilterProduct.js";
import FilterExpressType from "@/mixins/Filter/FilterExpressType";

import LoadDM from "@/mixins/LoadDM.js";
import SumTable from "@/components/SumTable.vue";
import SumGroupTable from "@/components/SumGroupTable.vue";

export default {
	components: { SumTable, SumGroupTable },
	mixins: [LoadDM, CurdPage, Filters, FilterSaler, FilterWarehouse, FilterCustomer, FilterClassify, FilterProduct, FilterExpressType],
	data() {
		return {
			dataModelNames: ["Order", "Order_item"],
			editorDataModel: "Order_item",
			activeName: "total",
			activeNameDetail: "product_color",
			filterFrontOrder: { field: "is_front_order", value: null },
			filterMetagender: { field: "meta_gender", value: null},
			options: [{
				value: '',
				label: '全部'
			},{
				value: 0,
				label: '不区分性别'
			}, {
				value: 1,
				label: '男'
			}, {
				value: 2,
				label: '女'
			}],
			sumGroups: [],
			dataBrandFields: [
				{
					name: "name"
				}
			],
			dataFields: [
        {
          name:"is_star",
          params: {
            isRight: true,
          },
          width: "60px",
          render: (info) => {
            let str = info.is_star
            if (str == 0) {
              str = ""
            }else {
              str = "<div style='color: #0e0e0e;font-size: 18px'>★</div>"
            }
            return str;
          },
        },
        {
          name:"thumb_img",
          fieldInfo: {
            oss_style: 'logo'
          }
        },
				{
					name: "brand"
				},
				{
					name: "brand_show_id"
				},
				{
					name: "name"
				},
				{
					name: "color_code"
				}
			],
			sumGroupFields: [
				{
					name: "sum_amount",
					title: "件数",
					sortable: "custom",
					toFixed: true,
					toFixedLength: 0
				},
				{
					name: "sum_total_price",
					title: "总价",
					sortable: "custom",
					toFixed: true,
					toFixedLength: 2
				},
				{
					name: "sum_total_cost",
					title: "总成本",
					sortable: "custom",
					toFixed: true,
					toFixedLength: 2
				},
				{
					name: "sum_gross_profit",
					title: "总利润",
					sortable: "custom",
					toFixed: true,
					toFixedLength: 2
				},
				{
					name: "profit_rate",
					title: "毛利率",
					postfix: "%",
					toFixed: true,
					toFixedLength: 2
				}
			],
			sumFields: [
				{
					name: "sum_amount",
					title: "件数"
				},
				{
					name: "sum_total_price",
					title: "总价"
				},
				{
					name: "sum_total_cost",
					title: "总成本 "
				},
				{
					name: "sum_gross_profit",
					title: "总利润"
				},
				{
					name: "profit_rate",
					title: "毛利率",
					postfix: "%"
				}
			],
      sorts: {
        sortKey: "sum_total_price",
        sortOrder: "desc"
      },
      paginations: {
        main: {
          pageNow: 1,
          total: 0,
          perPage: 50
        }
      },
      dateFilter: {
        type: Array
      },
      warehouseFilter: {
        type: Object,
        default: function() {
          return {
            _id: ""
          };
        }
      },
		};
	},
  props: {
    dataModel: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    listUrl: {
      type: String,
      default: ""
    },

    searchFilter: {
      type: String,
      default: ""
    },
    // dateFilter: {
    //   type: Array
    // },
    // warehouseFilter: {
    //   type: Object,
    //   default: function() {
    //     return {
    //       _id: ""
    //     };
    //   }
    // },
    autoLoad: {
      type: Boolean,
      default: true
    },
    hasPage: {
      type: Boolean,
      default: true
    },
    hasOpSlot: {
      type: Boolean,
      default: false
    },
    sortsDefault: {
      type: Object,
      default: function() {
        return {
          sortKey: "sum_total_price",
          sortOrder: "desc"
        };
      }
    }
  },
	computed: {},
	created() {},
	mounted() {},
	methods: {

    doProfitExport(dataModel, activeName = "", fieldsShow = null, url) {
      this.loadings.filter = true;
      url = `analyse/profit_export/${dataModel}`;

      if (!fieldsShow && this.$refs["sumGroupTable"]) {
        fieldsShow = this.$refs["sumGroupTable"].fieldsShow;
      }
      this.$axios.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
      this.$axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
      this.$axios
          .post(
              url,
              {
                page: this.hasPage ? this.paginations.main.pageNow : -999,
                sortKey: this.sorts.sortKey,
                sortOrder: this.sorts.sortOrder,
                searchFilter: this.searchFilter,
                dateFilter: this.filterHisDate,
                kvFilter: this.kvFilter,
                fieldsShow: [],
              },
              { responseType: "arraybuffer" },
          )
          .then(res => {
            this.loadings.filter = false;

            let blob = new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            });
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          })
          .catch(res => {
            console.error(res);
            this.loadings.filter = false;

            // 错误信息
          });
    },

  },
	watch: {
		"filterFrontOrder.value": {
			handler(newVal) {
				let val = this.filterFrontOrder;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		},
		"filterMetagender.value":{
			handler(newVal) {
				let val = this.filterMetagender;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
